import { useWatermark } from '@/context/WatermarkContext';

export function Watermark({ size = 'sm', className = '' }) {
  const { watermarkEnabled } = useWatermark();
  
  if (!watermarkEnabled) return null;
  
  const sizeClasses = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-4 py-1.5 text-sm',
    lg: 'px-4 py-2 text-sm'
  };
  
  return (
    <div className={`absolute bottom-3 right-3 bg-black/40 backdrop-blur-sm rounded-full ${sizeClasses[size]} ${className}`}>
      <span className="text-white/90 font-medium tracking-wide">kittens4sale.us</span>
    </div>
  );
}

export default Watermark;
